var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsPersonOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M20.99 21c0 .552-.402 1-.898 1H3.908c-.496 0-.899-.448-.899-1-.2-4.667 2.797-7 8.991-7 6.194 0 9.19 2.333 8.99 7zM12 16c-4.667 0-7 1.333-7 4h14c0-2.667-2.333-4-7-4zm0-4a5 5 0 11.001-10.001A5 5 0 0112 12zm0-2a3 3 0 100-6 3 3 0 000 6z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMDAzQTVEIiBkPSJNMjAuOTkgMjFjMCAuNTUyLS40MDIgMS0uODk4IDFIMy45MDhjLS40OTYgMC0uODk5LS40NDgtLjg5OS0xLS4yLTQuNjY3IDIuNzk3LTcgOC45OTEtNyA2LjE5NCAwIDkuMTkgMi4zMzMgOC45OSA3ek0xMiAxNmMtNC42NjcgMC03IDEuMzMzLTcgNGgxNGMwLTIuNjY3LTIuMzMzLTQtNy00em0wLTRjLTIuNzYxIDAtNS0yLjIzOS01LTVzMi4yMzktNSA1LTUgNSAyLjIzOSA1IDUtMi4yMzkgNS01IDV6bTAtMmMxLjY1NyAwIDMtMS4zNDMgMy0zcy0xLjM0My0zLTMtMy0zIDEuMzQzLTMgMyAxLjM0MyAzIDMgM3oiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconsPersonOutlined as ReactComponent };